import { AppState } from 'Store'

const selectEntries = (state: AppState) => state.orders.businessapps.list.entries
const selectCurrentParams = (state: AppState) => state.orders.businessapps.requestParams
const selectTotal = (state: AppState) => state.orders.businessapps.list.total_entries
const selectIsLoading = (state: AppState) => state.orders.businessapps.isLoading
const selectItem = (state: AppState) => state.orders.businessapps.edit

export const businessappsSelectors = {
	selectEntries,
	selectTotal,
	selectCurrentParams,
	selectIsLoading,
	selectItem,
}
